import { render, staticRenderFns } from "./GridWidget.vue?vue&type=template&id=67475c59&"
import script from "./GridWidget.vue?vue&type=script&lang=ts&"
export * from "./GridWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports